export default __webpack_public_path__ + "static/media/cm.509ee09e.svg";